const MarqueeBrand = function() {
    function MarqueeBrand() {
        this.selector = {
            container: document.getElementById("brand-marquee")
        }
        this.load();
    }
    MarqueeBrand.prototype.load = function() {
        var _ = this;
        if(_.selector.container) {
            $('#brand-marquee').slick({
                speed: 8000,
                autoplay: true,
                autoplaySpeed: 0,
                centerMode: false,
                cssEase: 'linear',
                slidesToShow: 1,
                draggable:false,
                focusOnSelect:false,
                pauseOnFocus:false,
                pauseOnHover:false,
                slidesToScroll: 1,
                variableWidth: true,
                infinite: true,
                initialSlide: 1,
                arrows: false,
                buttons: false
              });
        }
    }
    MarqueeBrand = new MarqueeBrand;
}

MarqueeBrand();